import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Nav from './Components/Nav';
import Home from './Pages/Home';
import Footer from './Components/Footer';
import Members from './Pages/Members';
import WhatWeDo from './Pages/WhatWeDo';
import Visit from './Pages/Visit';
import Events from './Pages/Events';
import Links from './Pages/Links';
import NewsPage from './Components/Home/NewsPage';
import SeminarPage from './Components/Home/SeminarPage';

const App = () => {
  return (
    <BrowserRouter basename='/string'>
    {/* <BrowserRouter basename='/string2022'> */}
    {/* <BrowserRouter>  */}
      <div className='App min-width'>
        <Nav />
        <div className='content'>
          <Routes>
            <Route path={"/"} element={<Home />} />
            <Route path={"/members"} element={<Members />} />
            <Route path={"/whatwedo"} element={<WhatWeDo />} />
            <Route path={"/visit"} element={<Visit />} />
            <Route path={"/events"} element={<Events />} />
            <Route path={"/links"} element={<Links />} />
            <Route path={"/news/:news_id"} element={<NewsPage />} />
            <Route path={"/seminar/:seminar_id"} element={<SeminarPage />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
